import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0570a9d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "when-get-solar"
}
const _hoisted_2 = { class: "h4 when-get-solar__title" }
const _hoisted_3 = { class: "h4 when-get-solar__title" }
const _hoisted_4 = { class: "h4 when-get-solar__title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon when-get-solar__next-button--icon icon-arrow-right" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Combobox = _resolveComponent("Combobox")!
  const _component_InputField = _resolveComponent("InputField")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_ctx.pageContent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.pageContent.whenGetSolarTitle), 1),
        _createVNode(_component_Combobox, {
          ref: "whenGetSolarOptions-combobox",
          modelValue: _ctx.selectedWhenGetSolar,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedWhenGetSolar) = $event)),
          "input-id": "select-whenGetSolar",
          options: _ctx.whenGetSolarOptions,
          label: "Please select",
          class: "mb-7 when-get-solar__when-get-solar-select form-group__input-group"
        }, null, 8, ["modelValue", "options"]),
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.pageContent.customerPreferenceTitle), 1),
        _createVNode(_component_Combobox, {
          ref: "CustomerPreference-combobox",
          modelValue: _ctx.selectedCustomerPreference,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCustomerPreference) = $event)),
          "input-id": "select-customerPreference",
          options: _ctx.customerPreferenceOptions,
          label: "Please select",
          class: "mb-7 when-get-solar__quote-preference-select form-group__input-group"
        }, null, 8, ["modelValue", "options"]),
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.pageContent.whoSuggestedTitle), 1),
        _createVNode(_component_Combobox, {
          ref: "whoSuggested-combobox",
          modelValue: _ctx.selectedWhoSuggested,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedWhoSuggested) = $event)),
          "input-id": "select-whoSuggested",
          options: _ctx.whoSuggestedOptions,
          label: "Please select",
          class: "mb-7 when-get-solar__who-suggested-select form-group__input-group"
        }, null, 8, ["modelValue", "options"]),
        (_ctx.selectedWhoSuggested?.value === 'Home Survey')
          ? (_openBlock(), _createBlock(_component_InputField, {
              key: 0,
              modelValue: _ctx.surveyorId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.surveyorId) = $event)),
              modelModifiers: { trim: true },
              class: "mb-7 when-get-solar__who-suggested-select-surveyor-ID-input form-group__input-group",
              name: "Surveyor ID Number",
              label: "Surveyor ID Number",
              maxlength: "4"
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (_ctx.selectedWhoSuggested?.value === 'Voucher Code')
          ? (_openBlock(), _createBlock(_component_InputField, {
              key: 1,
              modelValue: _ctx.voucherCode,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.voucherCode) = $event)),
              modelModifiers: { trim: true },
              class: "mb-7 when-get-solar__who-suggested-select-surveyor-ID-input form-group__input-group",
              name: "Voucher Code",
              label: "Voucher Code"
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        _createVNode(_component_AppButton, {
          class: "when-get-solar__next-button",
          "full-width": "",
          size: "large",
          disabled: 
        !_ctx.selectedWhenGetSolar ||
        !_ctx.selectedCustomerPreference ||
        !_ctx.selectedWhoSuggested ||
        (_ctx.selectedWhoSuggested.value === 'Home Survey' && !_ctx.surveyorId) ||
        (_ctx.selectedWhoSuggested.value === 'Voucher Code' && !_ctx.voucherCode)
      ,
          onClick: _ctx.next
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.pageContent.nextButton), 1),
            _hoisted_5
          ], undefined, true),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]))
    : _createCommentVNode("", true)
}